module.exports = __webpack_public_path__ + "static/img/he.ba412bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/he.jpg
// module id = 8WBt
// module chunks = 0